import { render, staticRenderFns } from "./tjDizhi.vue?vue&type=template&id=3945418a&scoped=true"
import script from "./tjDizhi.vue?vue&type=script&lang=js"
export * from "./tjDizhi.vue?vue&type=script&lang=js"
import style0 from "./tjDizhi.vue?vue&type=style&index=0&id=3945418a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3945418a",
  null
  
)

export default component.exports